export default __webpack_public_path__ + "static/media/home_decoration.8e56b61f.jpg";